import React from "react"
import { useSnackbar } from "notistack"
import { useRecoilState } from "recoil"
import Grid from "@material-ui/core/Grid"

import GoogleMapsField from "../components/GoogleMapsField"
import StepButtons from "../components/StepButtons"
import onboardingProgress from "../store/onboardingProgress"

export default function Location({ activeStep, handleBack, onSubmit, steps }) {
  const [isLoading, setIsLoading] = React.useState(false)
  const [progress, setProgress] = useRecoilState(onboardingProgress)
  const [address, setAddress] = React.useState({
    addressFull: progress.association.addressFull,
    latLong: {},
    addressParts: {},
  })
  const { enqueueSnackbar } = useSnackbar()

  function validateForm() {
    return address.addressFull.length > 0
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsLoading(true)
    if (address.addressParts.length) {
      const country = address.addressParts[address.addressParts.length - 1]?.value
      const state = address.addressParts[address.addressParts.length - 2]?.value
      if (country !== "USA") {
        enqueueSnackbar("Condo Axis is only supported in the USA currently.")
      } else if (state !== "IL") {
        enqueueSnackbar("Condo Axis is only supported in the state of Illinois currently.")
      } else {
        setProgress({
          ...progress,
          activeStep: progress.activeStep + 1,
          association: {
            ...progress.association,
            addressFull: address.addressFull,
            address: `${address.addressParts[0].value} ${address.addressParts[1].value}`,
            city: address.addressParts[address.addressParts.length - 3].value,
            state: state,
            country: country,
            location: {
              lat: address.latLong.lat,
              lng: address.latLong.lng,
            },
          },
        })
      }
    }
    setIsLoading(false)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <GoogleMapsField
            autoFocus
            label="Association Address"
            id="address"
            address={address}
            setAddress={setAddress}
            value={address.addressFull}
          />
        </Grid>
        <Grid item xs={12}>
          <StepButtons disableNext={!validateForm()} isLoading={isLoading} />
        </Grid>
      </Grid>
    </form>
  )
}
